module.exports = __webpack_public_path__ + "img/htmx.129084e6.png";